<form
  #userForm="ngForm"
  id="forms.userForm"
  role="form"
  name="forms.userForm"
  autocomplete="on"
  (submit)="save()"
  novalidate
>
  <div
    rvSpinner="user-settings"
    [rvShowSpinner]="loading"
    class="settings-page-container"
  >
    <div class="settings-page-body">
      <h3 class="tw-font-bold tw-text-4xl tw-mb-8">Add User</h3>
      <div id="user-settings">
        <user-fields [user]="user" [isAddMode]="true"></user-fields>
        <div
          id="errorBox"
          class="alert alert-danger tw-mt-4"
          role="alert"
          [shown]="formError"
        >
          <strong>{{ formError }}</strong> {{ apiError }}
        </div>
      </div>
    </div>
    <div class="settings-page-footer">
      <common-actions [actions]="actions" [saving]="loading"> </common-actions>
    </div>
  </div>
</form>
